import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";
import { VISITOR_API_ROUTES } from "../utils/visitorApiRoutes";
import { authJsonHeaders, buildApiError, parseJson } from "./apiHelpers";

const BASE = VISITOR_API_ROUTES.visitorPurpose;

export async function getVisitorPurposes() {
  const res = await authFetch(BASE, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to fetch visitor purposes");
  return data;
}

export async function createVisitorPurpose(body, csrfToken) {
  const res = await authFetch(BASE, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to create visitor purpose");
  return data;
}

export async function updateVisitorPurpose(id, body, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "PUT",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
    body: JSON.stringify(body),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to update visitor purpose");
  return data;
}

export async function deleteVisitorPurpose(id, csrfToken) {
  const res = await authFetch(`${BASE}/${encodeURIComponent(String(id))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(authJsonHeaders(csrfToken)),
  });
  const data = await parseJson(res);
  if (!res.ok) throw buildApiError(res, data, "Failed to delete visitor purpose");
  return data;
}
